<template>
  <div>
    <cx-check-box :value.sync="showLabel">显示区域标签</cx-check-box>
    <div v-show="showLabel">
      <label class="mt16 font14 inlineMiddle"> 默认文字样式 </label>
      <text-setting-update
        class="mt8"
        :fontColor.sync="labelFontColor"
        :fontFamily.sync="labelFontFamily"
        :fontSize.sync="labelFontSize"
        :fontWeight.sync="labelFontWeight"
      />
      <label class="mt16 font14 inlineMiddle"> 选中文字样式 </label>
      <text-setting-update
        class="mt8"
        :fontColor.sync="selectFontColor"
        :fontFamily.sync="selectFontFamily"
        :fontSize.sync="selectFontSize"
        :fontWeight.sync="selectFontWeight"
      />
    </div>
  </div>
</template>

<script>
export default {
  props: { options: Object },
  computed: {
    ids() {
      return this.$store.state.states.activeID
    },

    chartOption() {
      return this.options.chartOption
    },
    showLabel: {
      get() {
        return this.chartOption.showLabel
      },
      set(val) {
        this.$changeOptionsEV(val, "chartOption.showLabel", false)
      }
    },
    labelFontColor: {
      get() {
        return this.chartOption.label.labelFontColor
      },
      set(val) {
        this.$changeOptionsEV(val, "chartOption.label.labelFontColor", false)
      }
    },
    labelFontFamily: {
      get() {
        return this.chartOption.label.labelFontFamily
      },
      set(val) {
        this.$changeOptionsEV(val, "chartOption.label.labelFontFamily", false)
      }
    },
    labelFontSize: {
      get() {
        return this.chartOption.label.labelFontSize
      },
      set(val) {
        this.$changeOptionsEV(val, "chartOption.label.labelFontSize", false)
      }
    },
    labelFontWeight: {
      get() {
        return this.chartOption.label.labelFontWeight
      },
      set(val) {
        this.$changeOptionsEV(val, "chartOption.label.labelFontWeight", false)
      }
    },
    selectFontColor: {
      get() {
        return this.chartOption.select.selectFontColor
      },
      set(val) {
        this.$changeOptionsEV(val, "chartOption.select.selectFontColor", false)
      }
    },
    selectFontFamily: {
      get() {
        return this.chartOption.select.selectFontFamily
      },
      set(val) {
        this.$changeOptionsEV(val, "chartOption.select.selectFontFamily", false)
      }
    },
    selectFontSize: {
      get() {
        return this.chartOption.select.selectFontSize
      },
      set(val) {
        this.$changeOptionsEV(val, "chartOption.select.selectFontSize", false)
      }
    },
    selectFontWeight: {
      get() {
        return this.chartOption.select.selectFontWeight
      },
      set(val) {
        this.$changeOptionsEV(val, "chartOption.select.selectFontWeight", false)
      }
    }
  }
}
</script>

<style>
</style>